import {
  SearchCriteriaInput,
  SorterTypeEnum,
  SubscriptionPlanPageQueryVariables,
  SubscriptionPlanStatusEnum,
} from "@/generated/generated-hooks";

type GetInputVariableForSubscriptionPlansArgs = {
  userId: string;
  includeStringifyed?: boolean;
  channelId?: string;
  limit?: number;
};

export const getInputVariableForSubscriptionPlans = ({
  userId,
  channelId,
  includeStringifyed = false,
  limit,
}: GetInputVariableForSubscriptionPlansArgs) => {
  const statusFilter = includeStringifyed
    ? {
        in: [
          SubscriptionPlanStatusEnum.Published,
          SubscriptionPlanStatusEnum.Banned,
        ],
      }
    : { eq: SubscriptionPlanStatusEnum.Published };

  const searchCriteria: SearchCriteriaInput[] = [
    {
      field: "writerId",
      stringCriterion: { eq: userId },
    },
    {
      field: "subscriptionPlanStatus",
      stringCriterion: statusFilter,
    },
  ];

  if (channelId) {
    searchCriteria.push({
      field: "channelIds",
      stringCriterion: { eq: channelId },
    });
  }

  const result = {
    input: {
      searchCriteria,
      sorter: [
        { field: "price", type: SorterTypeEnum.Asc },
        { field: "createdAt", type: SorterTypeEnum.Desc },
      ],
      paging: { pageSize: limit },
    },
    includeStringifyed,
  };

  return result;
};

export const getChannelSubscriptionPlansInputVariable = (
  channelId: string,
  writerId: string,
): SubscriptionPlanPageQueryVariables => {
  const searchCriteria = [
    {
      field: "channelIds",
      stringCriterion: { eq: channelId },
    },
    {
      field: "writerId",
      stringCriterion: { eq: writerId },
    },
    {
      field: "subscriptionPlanStatus",
      stringCriterion: { eq: SubscriptionPlanStatusEnum.Published },
    },
  ];
  const obj = {
    input: {
      searchCriteria,
      sorter: [{ field: "price", type: SorterTypeEnum.Asc }],
    },
    includeStringifyed: false,
  };
  return obj;
};
